const ONES = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

const twoDigits = (n) => {
    if (n < 20) return ONES[n];
    return TENS[Math.floor(n / 10)] + (n % 10 ? ' ' + ONES[n % 10] : '');
};

const threeDigits = (n) => {
    if (n < 100) return twoDigits(n);
    const rest = n % 100;
    return ONES[Math.floor(n / 100)] + ' Hundred' + (rest ? ' and ' + twoDigits(rest) : '');
};

/** Indian numbering (Crore/Lakh/Thousand) rupee amount in words, e.g. "Twenty Seven Thousand One Hundred and Forty Rupees Only". */
export const amountInWordsINR = (amount) => {
    const rupees = Math.floor(Math.abs(Number(amount) || 0));
    if (rupees === 0) return 'Zero Rupees Only';

    const crore = Math.floor(rupees / 10000000);
    const lakh = Math.floor((rupees % 10000000) / 100000);
    const thousand = Math.floor((rupees % 100000) / 1000);
    const hundred = rupees % 1000;

    const parts = [];
    if (crore) parts.push(threeDigits(crore) + ' Crore');
    if (lakh) parts.push(threeDigits(lakh) + ' Lakh');
    if (thousand) parts.push(threeDigits(thousand) + ' Thousand');
    if (hundred) parts.push(threeDigits(hundred));

    return parts.join(' ') + ' Rupees Only';
};
